import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { laborHoursConstant } from 'src/redux/actions/constant';
import laborHoursService from 'src/services/apiServices/laborHoursService/laborHoursService';

function* approvePayPeriod(action: any): SagaReturnType<any> {
  try {
    yield put({ type: laborHoursConstant.APPROVE_PAY_PERIOD_LOADER });
    const response = yield call(laborHoursService.approvePayPeriod, action.payload);
    if (response?.status === 200 || response?.status === 201) {
      yield put({
        type: laborHoursConstant.APPROVE_PAY_PERIOD_SUCCESS,
        payload: response.data,
      });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: laborHoursConstant.APPROVE_PAY_PERIOD_FAILURE, payload: error });
  }
}

function* approvePayPeriodSaga() {
  yield takeLatest(laborHoursConstant.APPROVE_PAY_PERIOD_REQUEST, approvePayPeriod);
}

export default approvePayPeriodSaga;
